export default {
    LOAD_CONTENTPHOTOS (state, contentphotos) {
        state.items = contentphotos
    },
    LOAD_PHOTOS_BY_CONTENT (state, contentphotos) {
        state.fotos = contentphotos
    }
}